import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./AwardContent.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import AwardsTab from "./AwardsTab";

function AwardContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      {/* <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="awards-banner-container" id="main">
        <title>L-TT Awards</title>
        <h1 class="sr-only" tabIndex={0}>
          Awards
        </h1>
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Awards/Awards-Banner-Brand-New.png"
          }
          alt="award-banner"
          className="banner-img"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/awards"
            >
              Awards
            </NavLink>
          </li>
        </ul>
        <p data-aos="fade-up">
          Discover the numerous awards the L&TT team has won for excellence in
          learning and innovation over the years. These honors highlight our
          top-tier learning programs, processes, and strategies, which have
          strengthened the organization’s professional reputation.
        </p>
      </div> */}

      <div className="awards-yearwise-container">
        <div className="awards-yearwise-wrap">
          <div className="awards-yearwise-extra-row">
            <AwardsTab />
          </div>
        </div>
      </div>
    </>
  );
}

export default AwardContent;
